import { useBiddingSection } from '../useBiddingSection';

export const useHasValuationsToDisplay = (): boolean => {
	const { priceAverageCondition, priceGoodCondition, priceRetail } = useBiddingSection();
	return Boolean(priceGoodCondition || priceAverageCondition || priceRetail);
};
